import { useEffect, useState } from 'react';
import { white } from 'web-ui-kit/colors';

import { getBorderColorForState, VariantSelectionState } from '../utils';

const getShouldRender = (state) => {
  switch (state) {
    case VariantSelectionState.OUT_OF_STOCK:
    case VariantSelectionState.OUT_OF_STOCK_SELECTED:
    case VariantSelectionState.DISABLED:
      return true;
    default:
      return false;
  }
};

export default function StrikethroughLineState ({ state, type }) {
  const [borderColors, setBorderColors] = useState([getBorderColorForState(state)]);
  const [render, setRender] = useState(getShouldRender(state));

  useEffect(() => {
    const newBorderColors = [getBorderColorForState(state)];
    if (type === 'color') {
      newBorderColors.push(white);
    }
    setBorderColors(newBorderColors);
    setRender(getShouldRender(state));
  }, [state]);

  return [borderColors, render];
}
